import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-picker-icon',
  templateUrl: './design-picker.component.html'
})
export class DesignPickerComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
